
























































































































































































import { getOptionSlug } from '~/utils';
const _lowerCase = require('lodash.lowercase');
const _debounce = require('lodash.debounce');
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter, Mutation, State } from 'vuex-class';
import { IGame, IGameItemForSaleByGala } from '~/store/games/types';
import StoreItemCard from '~/components/Store/StoreItemCard.vue';
import StoreFilterControls from '~/components/Store/StoreFilterControls.vue';
import StoreFilters from '~/components/Store/StoreFilters.vue';
import itemsForSaleByGala from '~/queries/paginatedStoreItems.gql';
import getStoreFilters from '~/queries/storeFilters.gql';
import getStoreFiltersWithCurrencies from '~/queries/storeFiltersWithCurrencies.gql';
import { ISortOption } from '~/store/types';
import {
  GalaStoreToggleFilterCategory,
  IFilterOption,
  IFilterValue,
  IGalaStoreFilterOptions,
  IStoreItemsInput,
  IStoreTokenPrice,
} from '~/types/gala-store';
import InfiniteLoading from 'vue-infinite-loading';
import { Dictionary } from 'lodash';
import { IInventoryCollection } from '~/store/cms_content/types';

@Component({
  components: {
    StoreItemCard,
    StoreFilterControls,
    StoreFilters,
    InfiniteLoading,
  },
})
export default class StoreLayout extends Vue {
  @Prop({
    type: Object,
    default: () => ({}),
  })
  readonly defaultFilters!: IGalaStoreFilterOptions;
  @Getter('inventoryIconForCollectionName', { namespace: 'cmsContent' })
  collectionIcons!: Record<string, IInventoryCollection | undefined>;
  @State(profile => profile.user.goldMember, { namespace: 'profile' })
  readonly goldMember!: boolean;
  @State(shareState => shareState.founderNodesOwned, { namespace: 'share' })
  readonly founderNodesOwned!: number;
  @State(games => games.games, { namespace: 'games' })
  games!: IGame[];
  @State(profile => profile.user.walletExists, { namespace: 'profile' })
  walletExists!: boolean;
  @State(profile => profile.user.walletConnected, { namespace: 'profile' })
  walletConnected!: boolean;

  @Mutation toggleErrorSnackbar!: (payload?: boolean) => void;
  @Mutation updateSnackbarErrorText!: (args: any) => void;

  showStore = true;
  debounceTime = 1000;
  showFiltersDialog = false;
  storeItems: IGameItemForSaleByGala[] = [];
  currencies: string[] = [];
  sortOptions: ISortOption[] = [
    { title: 'Popularity', property: 'orderCount', direction: -1 },
    { title: 'Relevance', property: 'score', direction: -1 },
    {
      title: 'Price: Low to High',
      property: 'prices.usdPriceInCents',
      direction: 1,
    },
    {
      title: 'Price: High to Low',
      property: 'prices.usdPriceInCents',
      direction: -1,
    },
    { title: 'Newest Arrivals', property: 'dateAvailable', direction: -1 },
  ];
  usdPricesInCents: number[] = [];
  tokenPrice: IStoreTokenPrice = {
    token: '',
    usdPrice: 0,
    usdPriceDecimals: 0,
    tokenPriceInCents: 0,
  };
  filterOptions: IGalaStoreFilterOptions = {};
  selectedCurrency: ISortOption | null = null;
  selectedSort: ISortOption | null = null;
  searchTerm = '';
  searchKey = GalaStoreToggleFilterCategory.name;
  isFetching = false;
  gameForName?: Record<string, IGame>;
  page = 1;
  limit = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 10 : 30;
  infiniteId = +new Date();
  readyToScroll = false;
  totalItems = 0;

  get currencyOptions() {
    const all = { title: 'ALL', property: 'currency' };
    const currencies = this.currencies.map(currency => ({
      title: currency,
      property: 'currency',
    }));
    return [all, ...currencies];
  }

  get filtersToApply() {
    const filters: IGalaStoreFilterOptions = {};
    for (const key in this.filterOptions) {
      const category = { ...this.filterOptions[key] };
      category.values = category.values.filter(
        (option: IFilterValue) => option.selected,
      );
      if (category.values.length) {
        filters[key] = category;
      }
    }
    if (this.searchTerm) {
      filters[this.searchKey] = this.searchFilterOption;
    }
    return filters;
  }

  get filterChipsShown() {
    const filterChipsToShow = { ...this.filtersToApply };
    delete filterChipsToShow.name;
    if (this.hideGameFilters) {
      delete filterChipsToShow.games;
    }
    delete filterChipsToShow.price;
    return Object.entries(filterChipsToShow);
  }

  get hideGameFilters() {
    return this.$route?.name === 'games-name';
  }

  get searchFilterOption() {
    return {
      field: this.searchKey,
      type: 'string',
      values: [
        {
          name: this.searchTerm,
          selected: true,
          value: this.searchTerm,
          comparator: 'regex',
        },
      ],
    };
  }

  itemGameIsBlocked(gameName: string) {
    if (!this.gameForName && this.games?.length > 0) {
      this.gameForName = Object.fromEntries(
        this.games.map(game => [game.name, game]),
      );
    }

    return this.gameForName?.[gameName]?.isTotallyBlocked ?? false;
  }

  async created() {
    this.isFetching = true;
    try {
      await this.fetchFilterOptions(true);
    } catch (error) {
      this.$sentry.captureException(error);
      this.showStore = false;
      return;
    }
    this.initializeFiltersToApply();

    if (this.$route.name === 'games-name' && !this.filtersToApply.games) {
      this.showStore = false;
      this.isFetching = false;
      return;
    }

    this.readyToScroll = true;
  }

  setFilterOptions(
    options: IGalaStoreFilterOptions,
    appliedFilters: IGalaStoreFilterOptions,
  ) {
    if (appliedFilters) {
      for (const key in appliedFilters) {
        if (options.hasOwnProperty(key)) {
          appliedFilters[key].values.forEach((filter: IFilterValue) => {
            const index = options[key].values.findIndex(
              (option: IFilterValue) =>
                _lowerCase(option.name) === _lowerCase(filter.name),
            );
            if (index >= 0) {
              options[key].values[index].selected = true;
            }
          });
        }
      }
      this.filterOptions = options;
    }
  }

  initializeFiltersToApply() {
    const { query } = this.$route;
    const filters: IGalaStoreFilterOptions = {};
    for (const key in this.defaultFilters) {
      const options = this.defaultFilters[key];
      if (this.filterOptions.hasOwnProperty(key)) {
        filters[key] = options;
      }
    }

    for (const key in query) {
      const options = query[key];
      if (key === this.searchKey) {
        this.searchTerm = query[key] as string;
      }
      if (
        this.filterOptions.hasOwnProperty(key) &&
        typeof options === 'string'
      ) {
        const optionsArray = options.split(',');
        const { field, type } = this.filterOptions[key];
        const values = optionsArray.map(option => ({
          name: option,
          value: option,
          selected: true,
          comparator: 'eq',
        }));

        if (filters.hasOwnProperty(key)) {
          filters[key].values = values;
        } else {
          filters[key] = { field, type, values };
        }
      }
      if (key === 'selectedCurrency') {
        let foundCurrency = this.currencyOptions.find(
          e => getOptionSlug({ title: e.title }) === options,
        );
        if (!foundCurrency) return;
        this.handleCurrencySelected(foundCurrency as ISortOption);
      }
      if (key === 'sortOption') {
        let foundOption = this.sortOptions.find(
          e => getOptionSlug({ title: e.title }) === options,
        );
        if (!foundOption) return;
        this.handleSortSelected(foundOption);
      }
    }
    this.setFilterOptions(this.filterOptions, filters);
  }

  async fetchFilterOptions(initial?: boolean) {
    const gameFilter = this[initial ? 'defaultFilters' : 'filtersToApply']
      .games;
    let games = gameFilter ? gameFilter.values.map(val => val.name) : [];
    games = games.filter(val => val != 'Gala Music' && val != 'Gala Film');
    try {
      const results = (await this.$apollo.query({
        query: this.currencies.length
          ? getStoreFilters
          : getStoreFiltersWithCurrencies,
        variables: {
          currency: this.selectedCurrency
            ? this.selectedCurrency.title
            : 'GALA',
          games,
        },
        fetchPolicy: 'no-cache',
      })) as {
        data: {
          storeFilters: {
            filters: IGalaStoreFilterOptions;
            usdPricesInCents: number[];
            tokenPrice: IStoreTokenPrice;
            currencies: string[];
          };
        };
      };

      if (
        results.data &&
        results.data.storeFilters &&
        results.data.storeFilters.filters
      ) {
        results.data.storeFilters.filters.games.values = results.data.storeFilters.filters.games.values.filter(
          g => !this.itemGameIsBlocked(g.name),
        );

        const {
          filters,
          usdPricesInCents,
          tokenPrice,
          currencies,
        } = results.data.storeFilters;

        if (currencies) {
          this.currencies = currencies;
        }
        this.usdPricesInCents = usdPricesInCents;
        this.tokenPrice = tokenPrice;
        delete filters.__typename;

        filters.games.values.forEach(element => {
          const translatedName =
            this.collectionIcons[element.name]?.displayName ||
            this.collectionIcons[element.name]?.name;
          if (translatedName) {
            element.name = translatedName;
          }
        });

        this.setFilterOptions(filters, this.filtersToApply);
      }
    } catch (error) {
      this.$sentry.captureException(error);
      console.warn(error);
      throw error;
    }
  }

  async fetchItems($state?: any) {
    try {
      this.isFetching = true;
      const paginatedStoreItemsInput = this.buildStoreItemsInput();
      const results = (await this.$apollo.query({
        query: itemsForSaleByGala,
        variables: {
          paginatedStoreItemsInput,
        },
        fetchPolicy: 'no-cache',
      })) as {
        data: {
          paginatedStoreItems: {
            products: any[];
            page: number;
            total: number;
            lastPage?: number;
          };
        };
      };

      if (results?.data?.paginatedStoreItems) {
        const data = results.data.paginatedStoreItems;
        this.totalItems = data.total;

        if (data.products.length === 0) {
          $state?.complete();
          this.$emit('items', []);
          this.isFetching = false;
          return;
        }

        // filter user specific criteria
        this.storeItems.push(
          ...data.products.filter(item => !this.itemGameIsBlocked(item.game)),
        );
        this.$emit('items', this.storeItems);
        this.setFilterOptions(this.filterOptions, this.filtersToApply);
        this.page++;
        $state?.loaded();

        if (!data.lastPage || data.lastPage <= data.page) {
          $state?.complete();
        }
      }
      this.isFetching = false;
    } catch (error) {
      this.$sentry.captureException(error);
      console.warn(error);
      this.isFetching = false;
      $state?.complete();
      this.updateSnackbarErrorText(
        this.$t('components.store.storeLayout.storeItemsError'),
      );
      this.toggleErrorSnackbar();
    }
  }

  buildStoreItemsInput() {
    const stringFilterOptions: IFilterOption[] = [];
    const numberFilterOptions: IFilterOption[] = [];

    const allocateFilter = (type: string, filter: IFilterOption) => {
      if (type === 'string') {
        stringFilterOptions.push(filter);
      } else if (type === 'number') {
        filter.value = +filter.value;
        numberFilterOptions.push(filter);
      }
    };

    for (const category in this.filtersToApply) {
      const { field, comparator, type, values } = this.filtersToApply[category];
      if (!comparator) {
        if (
          field === 'supply.currentSupply' &&
          values.length > 1 &&
          values.every(supplyVal => supplyVal.selected)
        ) {
          continue;
        }
        values.forEach((option: IFilterValue) => {
          const filter = {
            field,
            value: option.value,
            comparator: option.comparator,
          };

          if (filter.value !== undefined && filter.comparator) {
            allocateFilter(type, filter);
          }
        });
      } else {
        const filter = {
          field,
          value: values.map((val: IFilterValue) => val.value),
          comparator,
        };

        allocateFilter(type, filter);
      }
    }
    const storeItemsInput: IStoreItemsInput = {
      platform: 'platform',
      currency:
        this.selectedCurrency && this.selectedCurrency.title === 'ALL'
          ? ''
          : this.selectedCurrency
          ? this.selectedCurrency.title
          : 'GALA',
      limit: this.limit,
      page: this.page,
      hasWallet: this.walletExists || this.walletConnected,
    };

    if (stringFilterOptions.length) {
      storeItemsInput.stringFilterOptions = stringFilterOptions;
    }
    if (numberFilterOptions.length) {
      storeItemsInput.numberFilterOptions = numberFilterOptions;
    }

    const sortOption = this.buildSortOption();

    if (sortOption) {
      storeItemsInput.sortOptions = sortOption;
    }

    return storeItemsInput;
  }

  buildSearchFilter() {
    return this.searchTerm
      ? {
          field: 'name',
          value: this.searchTerm,
          comparator: 'regex',
        }
      : null;
  }

  buildSortOption() {
    return this.selectedSort
      ? {
          sortField: this.selectedSort.property,
          sortDirection: this.selectedSort.direction,
        }
      : null;
  }

  resetStoreItems() {
    this.page = 1;
    this.storeItems = [];
    this.infiniteId++;
  }

  handleCurrencySelected(currency: ISortOption) {
    this.selectedCurrency = currency;
    let formattedSlug = getOptionSlug(currency);
    this.$router.push({
      path: this.$router.currentRoute.path,
      query: {
        ...this.$route.query,
        selectedCurrency: formattedSlug,
      },
    });
    if (
      this.filtersToApply &&
      this.filtersToApply.price &&
      this.filterOptions &&
      this.filterOptions.price
    ) {
      // This removes the price filter when switching currency
      this.filterOptions.price.values.forEach(filter => {
        this.clearFilter('price', filter);
      });
    }
  }
  handleSortSelected(sortOption: ISortOption) {
    this.selectedSort = sortOption;
    let formattedSlug = getOptionSlug(sortOption);
    this.$router.push({
      path: this.$router.currentRoute.path,
      query: {
        ...this.$route.query,
        sortOption: formattedSlug,
      },
    });
    this.storeItems = [];
  }

  handleToggleFilterChange({
    type,
    name,
    selected,
    value,
  }: {
    type: GalaStoreToggleFilterCategory;
    name: string;
    selected: boolean;
    value?: number | string;
  }) {
    const index = this.filterOptions[type].values.findIndex(
      (option: IFilterValue) => option.name === name,
    );
    if (index >= 0) {
      this.filterOptions[type].values[index].selected = selected;

      if (value) {
        this.filterOptions[type].values[index].value = value;
      }
    }
    this.reloadQueryValues(type);
  }

  reloadQueryValues(category: string) {
    let newQuery: { [key: string]: any } = {};
    if (category === GalaStoreToggleFilterCategory.price) {
      newQuery = { ...this.$route.query };
      this.filterOptions[category]?.values.forEach(e => {
        newQuery[e.name] = e.value;
      });
    } else {
      let arr: (string | number)[] = [];
      this.filterOptions[category]?.values.forEach(e => {
        if (e.selected) {
          arr.push(
            getOptionSlug({ title: e.value === '0' ? e.name : e.value }),
          );
        }
      });
      newQuery = { ...this.$route.query, [category]: arr.join(',') };
      if (!arr.length) {
        delete newQuery[category];
      }
    }
    this.$router.push({
      path: this.$router.currentRoute.path,
      query: newQuery,
    });
  }

  clearFilter(category?: string, filter?: IFilterValue) {
    if (filter) {
      if (category === this.searchKey) {
        this.searchTerm = '';
        this.reloadQueryValues(category);
      } else if (category) {
        const filters = this.filterOptions[category].values;
        const index = filters.findIndex(
          (option: IFilterValue) => option.name === filter.name,
        );
        filters[index].selected = false;
        this.reloadQueryValues(category);
      }
    } else {
      this.clearAllToggleFilters();
    }
  }

  clearAllToggleFilters() {
    for (const key in this.filterOptions) {
      this.filterOptions[key].values.forEach((option: IFilterValue) => {
        const doNothing =
          this.hideGameFilters && this.filterOptions[key].field === 'game';
        if (!doNothing) {
          option.selected = false;
        }
      });
    }

    const newQuery = Object.entries(this.$route.query).reduce(
      (query, [key, value]) => {
        if (['sortOption', 'name'].includes(key)) {
          query[key] = value;
        }
        return query;
      },
      {} as Dictionary<any>,
    );
    this.$router.push({
      path: this.$router.currentRoute.path,
      query: newQuery,
    });
  }

  goToItem(item: any) {
    const routeCurrency =
      this.selectedCurrency && this.selectedCurrency.title !== 'ALL'
        ? this.selectedCurrency.title
        : item.prices[0].symbol;
    const link = `/games/buy-item/${item.baseId}?currency=${routeCurrency}`;

    this.$router.push(link);
  }

  debounceHandler = _debounce((cb: Function) => {
    cb();
  }, this.debounceTime);

  @Watch('currencyOptions', { immediate: true })
  handleCurrencyOptionsReady(options: ISortOption[]) {
    if (options.length) {
      this.selectedCurrency = options[0];
    }
  }
  @Watch('sortOptions', { immediate: true })
  handleSortOptionsReady(options: ISortOption[]) {
    if (options.length) {
      const { sort } = this.$route.query;
      if (sort && typeof sort === 'string') {
        const [property, direction] = sort.split(',');
        const sortOption = options.find(option => {
          const sortDirection = direction && +direction === 1 ? 1 : -1;
          return (
            option.property === property && option.direction === sortDirection
          );
        });
        if (sortOption) {
          this.selectedSort = sortOption;
        } else {
          this.selectedSort = options[options.length - 1];
        }
      } else {
        this.selectedSort = options[options.length - 1];
      }
    }
  }

  @Watch('$route')
  handleRouteChange() {
    this.initializeFiltersToApply();
    this.resetStoreItems();
  }

  @Watch('isFetching')
  handleFetchingChanged(value: boolean) {
    this.$emit('loading', value);
  }
}
